import { render, staticRenderFns } from "./AvisoErros.vue?vue&type=template&id=a364d73e"
import script from "./AvisoErros.vue?vue&type=script&lang=js"
export * from "./AvisoErros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports